import React, { useState } from "react";
export const environmentContext = React.createContext({
  environment: "production" as "production" | "sandbox",
  setEnvironment: (_value: "production" | "sandbox") => {},
});

const EnvironmentContextProvider = (props: any) => {
  // Initialize environment from URL parameter or default to "production"
  const getInitialEnvironment = (): "production" | "sandbox" => {
    const urlParams = new URLSearchParams(window.location.search);
    const envParam = urlParams.get("env");
    return envParam === "sandbox" ? "sandbox" : "production";
  };

  const [environment, setEnvironment] = useState<"production" | "sandbox">(getInitialEnvironment);

  // Enhanced setEnvironment that updates URL parameter
  const setAndUpdateURL = (value: "production" | "sandbox") => {
    const url = new URL(window.location.href);
    url.searchParams.set("env", value);
    window.history.replaceState({}, "", url.toString());
    setEnvironment(value);
  };

  return (
    <environmentContext.Provider
      value={{
        environment: environment,
        setEnvironment: setAndUpdateURL,
      }}
    >
      {props.children}
    </environmentContext.Provider>
  );
};

export default EnvironmentContextProvider;